import { ref } from 'vue'

export const showNewVersionAvailable = ref(false)
